import React from "react";
import { Modal, Segment, Header, Button, Icon } from "semantic-ui-react";
import SubScannerForm from "react-lib/apps/common/SubScannerForm";
import { useIntl } from "react-intl";

interface ModEditDocumentProps {
 testId?: string | number;
 size?: string;
 headerColor?: string;
 headerText?: string;
 isLoading?: boolean;
 onClose?: () => void;
 data?: Record<string,any>;
 onGetDocumentTypeOptions?: () => void;
 divisionOptions?: any[];
 categoryOptions?: any[];
 onCancelApprove?: () => void;
 cancelDocError?: Record<string,any> | string;
 editDocError?: Record<string,any> | string;
 loading?: boolean;
 onEditApprove?: () => void;
 closeIcon?: boolean;
 hideButtonCancel?: boolean;
 buttonEditTextTh?: boolean;
 showDocumentCategory?: boolean;
 onGetSearchOptions?: () => void;
 onIconClose?: () => void;
}

const DEFAULT_PROPS = {
  testId: "",
  size: "tiny",
  headerColor: "yellow",
  headerText: "แก้ไข",
  isLoading: false,
  onClose: () => { },
  data: {},
  onGetDocumentTypeOptions: () => [null, null],
  divisionOptions: [],
  categoryOptions: [],
  onCancelApprove: () => { },
  cancelDocError: null,
  editDocError: null,
  loading: false,
  onEditApprove: () => { },
  onGetSearchOptions: () => { },
  closeIcon: false,
  hideButtonCancel: false,
  buttonEditTextTh: false,
  showDocumentCategory: false,
  onIconClose: () => { }
}

const ModEditDocument = React.forwardRef<any,ModEditDocumentProps>((propsParam, ref) => {

  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  
  return (
    <Modal
      testid={"modEditDocument" + props.testId}
      open={props.open}
      size={props.size}
      closeOnDimmerClick={true}
      onClose={props.onClose}
    >
      <Segment
        className={"inverted " + props.headerColor}
        style={styles.header}
      >
        {props.headerText}
        {props.closeIcon &&
          <Icon name="close" style={{ float: "right", cursor: "pointer" }} onClick={props.onIconClose} />
        }
      </Segment>
      <Segment basic loading={props.isLoading}>
        <SubScannerForm
          // @ts-ignore
          data={props.data}
          onGetDocumentTypeOptions={props.onGetDocumentTypeOptions}
          divisionOptions={props.divisionOptions}
          onCancelApprove={props.onCancelApprove}
          onEditApprove={props.onEditApprove}
          cancelDocError={props.cancelDocError}
          editDocError={props.editDocError}
          loading={props.loading}
          hideButtonCancel={props.hideButtonCancel}
          buttonEditTextTh={props.buttonEditTextTh}
          showDocumentCategory={props.showDocumentCategory}
          categoryOptions={props.categoryOptions}
          onGetSearchOptions={props.onGetSearchOptions}
          languageUX={props.languageUX}
        />
      </Segment>
    </Modal>
  );
});

ModEditDocument.displayName = "ModEditDocument"

const styles = {
  header: {
    borderRadius: 0,
    fontWeight: "bold"
  }
};

export default React.memo(ModEditDocument);
